<a routerLink="/account">
  <span class="material-symbols-rounded-m">person</span>
  <span>{{ 'MY_PROFILE' | translate }}</span>
</a>

<button class="reset" (click)="authService.logout()">
  <span class="material-symbols-rounded-m">logout</span>
  <span>{{ 'LOG_OUT' | translate }}</span>
</button>
